var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{attrs:{"disabled":_vm.disabled,"type":"danger","icon":"el-icon-delete","size":"mini"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }